export default class ContactPerson {
  name: string = "";
  email: string = "";
  phone: string = "";
  dialCode: string = "";
}
